<template lang="pug">
  b-modal#reviewDetail(
  ref="reviewDetail"
  :title="$t('ui.review_detail')"
  centered
  no-fade
  no-close-on-backdrop
  ok-only
  :busy="loading"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success")
      b-form-group(:label="$t('ui.account_id')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="account_id"
          type="text"
          v-model="account_id"
          :disabled="loading"
        )
      //- b-form-group(:label="$t('ui.recipient_no')" disabled).mb-0
      //-   DebounceInput(
      //-     size="sm"
      //-     ref="recipient_no"
      //-     type="text"
      //-     v-model="recipient_no"
      //-     :disabled="loading"
      //-   )
      b-form-group(:label="$t('ui.comment')" disabled).mb-0
        b-form-textarea(v-model="comment" style="height:80px;")
      div
        b-form-group(:label="$t('ui.detail')").mb-0
          div.row.mb-3.animated.fadeIn
            div.col
              table.tablex(style="width: 100%;")
                thead
                  tr
                    th
                      span {{ $t('ui.question') }}
                    th
                      span {{ $t('ui.rating') }}
                tbody
                  tr(v-for="(item, index) in questionList")
                    td
                      b-form-textarea(rows="3" :value="item.question" :disabled="true")
                    td
                      span(v-for="score in 5")
                        a.fas.fa-star.text-warning(v-if="score <= item.rating")
                        a.far.fa-star.text-dark(v-else)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-check" :text="$t('ui.close')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
  },
  props: {
    item:{
      type: Object,
      default: null
    },
  },
  data() {
    return {
      questionList: [],
      account_id: "",
      recipient_no: "",
      comment: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
  },
  methods: {
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.account_id = this.item.account_id;
      this.recipient_no = this.item.recipient_no;
      this.comment = this.item.comment;
      this.getReviewDetail();
    },
    getReviewDetail: function() {
      let url = config.reviewDetailUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        review_id: this.item ? this.item.id : 0
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if (response.data.dt.length > 0) {
                  this.questionList = response.data.dt;
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    closeModal: function() {
      this.$refs.reviewDetail.hide();
    },
  }
};
</script>
